import { Modal } from 'react-bootstrap-v5'
import { useState, useCallback } from 'react';
import lancamentosExtratoService from '../../services/lancamentosExtratoService';
import moment from 'moment';

const ModalGerenciarLancamentos = ({ show, toggleModal, esteiraID, acc }: { show: boolean, toggleModal: Function, esteiraID: number, acc: string }) => {

    const [lancamentos, setLancamentos] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);


    const onRemove = useCallback(async (id: any) => {
        setLoading(true);
        await lancamentosExtratoService.remover(id);
        setLancamentos((old) => {
            const cp = [...old];
            return cp.filter(f => f.id !== id);
        })
        setLoading(false);
    }, []);

    return (
        <>
            <Modal size='lg' centered={true} show={show} onHide={toggleModal}>
                <div className="modal-content" style={{ backgroundColor: '#F4F5F7' }}>
                    <div className="modal-header">
                        <h5 className="modal-title titulo-modal">Gerenciar Lançamentos - {acc}</h5>
                        <div className="btn btn-icon btn-sm btn-active-light-primary ms-2">
                            <i onClick={() => toggleModal()} className="fas fa-times" style={{ color: '#5E6397' }}></i>
                        </div>
                    </div>
                    <div className="modal-body">
                        <div className='row'>
                            {loading && (
                                <div className="spinner-border text-success" role="status" style={{ marginBottom: '5px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                                    <span className="sr-only">Loading...</span>
                                </div>
                            )}

                            {!loading && lancamentos.length <= 0 && (
                                <i className="mt-2 mb-1">Nenhum lançamento foi encontrado.</i>
                            )}

                            {!loading && lancamentos.length > 0 && (
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th scope="col">#</th>
                                            <th scope="col">Data</th>
                                            <th scope="col">Conta</th>
                                            <th scope="col">Histórico</th>
                                            <th scope="col">Valor</th>
                                            <th scope="col">Tipo</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {lancamentos.map((item) => (
                                            <tr>
                                                <th scope="row"><button className='btn btn-danger' onClick={() => onRemove(item.id)}>
                                                    Desativar</button></th>
                                                <td>{moment(item.dataLancamento).format('DD/MM/YYYY')}</td>
                                                <td>{item.codigoContabil}</td>
                                                <td>{item.historico}</td>
                                                <td>{item.valorProvisaoRecolher.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                                                <td>{item.tipoLancamento}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default ModalGerenciarLancamentos